import { NextPageContext } from 'next'
import { GlobalSearchResult, SearchResult } from '../../types'
import { basePath, callAPI, callAuthAPI } from './common'

export const getSearchResult = async (keyword?: string) => {
  const qs = new URLSearchParams({ q: keyword || '' })
  const url = `${basePath}/pages/search?${qs}`
  const res = await callAPI<SearchResult>(url)
  return res
}

export const getGlobalSearchResult = async (
  ctx: NextPageContext,
  keyword?: string
) => {
  const qs = new URLSearchParams({ q: keyword || '' })
  const url = `${basePath}/pages/global_search?${qs}`
  const res = await callAuthAPI<GlobalSearchResult>(ctx, url)
  return res
}
